import { type Getter, atom, type Atom } from "jotai";

export function atomRequired<T>(
  getValue: ((get: Getter) => T) | Atom<T>,
  message?: string
) {
  return atom((get) => {
    let value;
    if (typeof getValue === "function") {
      value = getValue(get);
    } else {
      value = get(getValue);
    }

    if (value === undefined || value === null) {
      throw new Error(message ?? "Value is required");
    }
    return value;
  });
}
